export default "__VITE_ASSET__DaYzw5Au__"